import React from 'react';
import Reflux from 'reflux';
import RoleHelper from 'shared/lib/role';
import UserSessionStore from 'flux/stores/UserSessionStore';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

/**
 * DisplayForRole wrapper...used to allow (or not allow) a role to do see something
 *
 */
let DisplayForRole = React.createClass({
  mixins: [Reflux.connect(UserSessionStore, 'user')],

  propTypes: {
    scope: React.PropTypes.object,
    role: React.PropTypes.array,
    roles: React.PropTypes.array,
  },

  displayName: 'DisplayForRole',

  render() {
    let user = this.state.user;

    if (!user) return null;

    let { scope, role, roles, teamId, eventId } = this.props;

    if (!roles) roles = [{ role, scope }];

    if (RoleHelper.hasTeamAdminWithoutEventRole(user, teamId, eventId)) {
      return this.props.children;
    }

    if (!RoleHelper.hasSome(user, roles)) return null;

    return this.props.children;
  },
});

export const DisplayForAdmin = ({
  teamId,
  eventId,
  includeTeamAdmin,
  children,
}) => {
  let roles = RoleHelper.eventAdminRoles(teamId, eventId, includeTeamAdmin);

  return (
    <DisplayForRole roles={roles} teamId={teamId} eventId={eventId}>
      {children}
    </DisplayForRole>
  );
};

export const DisplayForNonAdmin = ({ teamId, eventId, children }) => {
  let roles = RoleHelper.eventNonAdminRoles(eventId);

  return (
    <DisplayForRole roles={roles} teamId={teamId} eventId={eventId}>
      {children}
    </DisplayForRole>
  );
};

export const DisplayForTeamAdmin = (props) => {
  let roles = RoleHelper.teamAdminRoles(props.teamId);

  return <DisplayForRole roles={roles}>{props.children}</DisplayForRole>;
};

export default DisplayForRole;
